// extracted by mini-css-extract-plugin
export default {"volume":"VolumeInput_volume__yCaGF"};